import * as React from "react";
import { useId } from "@react-aria/utils";
import { BaseModal } from "../BaseModal/BaseModal";
import { DEFAULT_MOBILE_BREAKPOINT, useViewportWidth } from "../../helpers";
import { cx } from "../../helpers/utils/cx";
import { BottomSheet } from "../..";
const sizes = {
  sm: "sm:w-[360px]",
  md: "sm:w-[480px]",
  lg: "sm:w-[640px]",
  xl: "sm:w-[736px]",
  custom: "sm:w-auto"
};
export function Drawer(_ref) {
  let {
    isOpen,
    title,
    onRequestClose,
    size = "md",
    children,
    useBottomSheet
  } = _ref;
  const titleId = useId();
  const {
    width
  } = useViewportWidth();
  const handleOnOpenChange = React.useCallback(newOpen => {
    if (!newOpen) {
      onRequestClose();
    }
  }, [onRequestClose]);
  if (width < DEFAULT_MOBILE_BREAKPOINT && useBottomSheet) {
    return /*#__PURE__*/React.createElement(BottomSheet, {
      isOpen: isOpen,
      onOpenChange: handleOnOpenChange
    }, /*#__PURE__*/React.createElement("div", {
      className: cx("w-[calc(100vw-1rem)]", sizes[size], "h-full flex flex-col", "bg-layer-floor-1 text-primary rounded-lg")
    }, /*#__PURE__*/React.createElement(BaseModal.Header, {
      title: title,
      titleId: titleId
    }, /*#__PURE__*/React.createElement(BaseModal.Close, {
      onClose: onRequestClose
    })), children));
  }
  return /*#__PURE__*/React.createElement(BaseModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose
    // 0.5rem side paddings, override user-agent max-h limitation, hack to ensure content goes full height.
    ,
    placement: "mr-2 mt-2 mb-2 ml-2 sm:ml-auto inset h-[calc(100vh-1rem)] max-h-full [&>div:first-child]:h-full",
    shape: "shadow-lg rounded-lg",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("w-[calc(100vw-1rem)]", sizes[size], "h-full flex flex-col", "bg-layer-floor-1 text-primary rounded-lg")
  }, /*#__PURE__*/React.createElement(BaseModal.Header, {
    title: title,
    titleId: titleId
  }, /*#__PURE__*/React.createElement(BaseModal.Close, {
    onClose: onRequestClose
  })), children));
}
function DrawerFooter(_ref2) {
  let {
    children
  } = _ref2;
  // split children to pieces, assuming that we get them in this order:
  // <Primary action>, <Secondary action>, ...<All the rest>

  const [primaryAction, secondaryAction, ...remainingActions] = React.Children.toArray(children);
  return /*#__PURE__*/React.createElement("footer", {
    className: cx("pt-4 pr-6 pb-6 pl-6", "flex gap-4 flex-row-reverse justify-between")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-4 flex-row-reverse ")
  }, primaryAction, secondaryAction), /*#__PURE__*/React.createElement("div", null, remainingActions));
}
Drawer.Content = BaseModal.Content;
Drawer.Footer = DrawerFooter;